import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Header from './components/Header';
import Hero from './components/Hero';
import Configurator from './components/Configurator';
import './App.css';
import Advantages from "./components/Advantages";
import Subscription from "./components/Subscription";
import Reviews from "./components/Reviews";
import Menu from "./components/Menu";
import Contact from "./components/Contact";
import WhereWeAre from "./components/WhereWeAre";
import Footer from "./components/Footer";
import HowItWorksFlow from "./components/HowItWorksFlow";
import { initAnalytics, trackPageView } from './utils/analytics';
import DebugButton from "./components/DebugButton";
import { loadTranslations } from './i18n/i18n';

function App() {
    const { t, i18n, ready } = useTranslation();
    const [translationsLoaded, setTranslationsLoaded] = useState(false);
    const [loading, setLoading] = useState(true);

    // Load translations from Firestore
    useEffect(() => {
        const loadTranslationsAsync = async () => {
            try {
                await loadTranslations();
                setTranslationsLoaded(true);
            } catch (error) {
                console.error('Error loading translations:', error);
                // Still set to true to continue with fallback translations
                setTranslationsLoaded(true);
            } finally {
                setLoading(false);
            }
        };

        loadTranslationsAsync();
    }, []);

    // Initialize analytics when the component mounts
    useEffect(() => {
        if (translationsLoaded) {
            initAnalytics();
            trackPageView(t('common.homePage', 'Home Page'));
        }
    }, [translationsLoaded, t]);

    if (loading) {
        return (
            <div className="min-h-screen bg-gray-50 flex items-center justify-center">
                <p className="text-xl text-gray-600">Caricamento...</p>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-gray-50">
            <Header/>
            <Hero/>
            <HowItWorksFlow/>
            <Configurator/>
            <Menu/>
            {/*<Advantages/>*/}
            <Subscription/>
            {/*<Reviews/>*/}
            <WhereWeAre/>
            <Contact/>
            <Footer/>
            {/*{process.env.NODE_ENV === 'development' && <DebugButton/>}*/}
        </div>
    );
}

export default App;
